<template>
	<div>
		<a-page-header style="background: #fff;" title="户型详情" />
		<a-row>
			<a-col :span="8">
				<div class="mainBox">
					<div class="contentBox" v-if="basicForm">
						<a-page-header :ghost="false" :title="basicForm.housetypeName" :subTitle="'ID ' + basicForm.id">
							<a-descriptions size="small" :column="1">
								<a-descriptions-item label="户型介绍"><strong>{{basicForm.housetypeName}}</strong></a-descriptions-item>
								<a-descriptions-item label="套内面积"><strong>{{basicForm.housetypeInArea}} 平方米</strong></a-descriptions-item>
								<a-descriptions-item label="建筑面积"><strong>{{basicForm.housetypeBuildArea}} 平方米</strong></a-descriptions-item>
								<a-descriptions-item label="朝向"><strong>{{basicForm.housetypeOrientation}}</strong></a-descriptions-item>
								<a-descriptions-item label="所属楼盘"><strong>{{basicForm.housetypeHouseName}}</strong></a-descriptions-item>
								<a-descriptions-item label="展示图">
									<img :src="item.url" alt="" v-for="(item,index) in basicForm.housetypePic" style="margin:5px;width: 100%;"
									 :key="index">
								</a-descriptions-item>
								<a-descriptions-item label="添加时间">{{basicForm.addTime}}</a-descriptions-item>
							</a-descriptions>
						</a-page-header>
					</div>
				</div>
			</a-col>

			<a-col :span="16" style="padding: 20px 20px 20px 0;">
				<div style="background: #fff;padding:20px">
					<a-form-model ref="basicForm" :model="basicForm" :rules="basicFormRules" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-form-model-item label="户型名称" prop="housetypeName">
							<a-input v-model="basicForm.housetypeName"></a-input>
						</a-form-model-item>
						<a-form-model-item label="户型介绍" prop="housetypeCont">
							<a-textarea v-model="basicForm.housetypeCont" :auto-size="{ minRows: 3, maxRows: 5 }"></a-textarea>
						</a-form-model-item>
						<a-form-model-item label="主力户型" prop='housetypeMain'>
							<a-switch checked-children="是" un-checked-children="否" v-model="basicForm.housetypeMain" default-checked />
						</a-form-model-item>
						<a-form-model-item label="套内面积" prop='housetypeInArea'>
							<a-input v-model="basicForm.housetypeInArea" suffix="平方米"></a-input>
						</a-form-model-item>
						<a-form-model-item label="建筑面积" prop='housetypeBuildArea'>
							<a-input v-model="basicForm.housetypeBuildArea" suffix="平方米"></a-input>
						</a-form-model-item>
						<a-form-model-item label="朝向" prop='housetypeOrientation'>
							<a-input v-model="basicForm.housetypeOrientation"></a-input>
						</a-form-model-item>
						<a-form-model-item label="展示图" prop='housetypePic'>
							<a-upload name="img" :multiple="true" listType="picture-card" class="avatar-uploader" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
							 :file-list="fileList" @preview="handlePreview" @change="photoChange">
								<div>
									<a-icon :type="loading ? 'loading' : 'plus'" />
									<div class="ant-upload-text">展示图</div>
								</div>
							</a-upload>
						</a-form-model-item>
						<a-form-model-item label="所属楼盘" prop='housetypeHouse'>
							<a-select v-model="basicForm.housetypeHouse" :options="houseList">
							</a-select>
						</a-form-model-item>
						<a-form-model-item style="text-align: center;">
							<a-button type="primary" @click="basicSubmit">
								保存
							</a-button>
						</a-form-model-item>
					</a-form-model>
				</div>
			</a-col>
		</a-row>

		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 14
				},
				houseList: [],
				fileList: [],
				basicForm: {},
				basicFormRules: {
					housetypeName: [{
						required: true,
						message: '请填写户型名称',
						trigger: 'blur'
					}],
					housetypeInArea: [{
						required: true,
						message: '请填写套内面积',
						trigger: 'blur'
					}],
					housetypeBuildArea: [{
						required: true,
						message: '请填写建筑面积',
						trigger: 'blur'
					}],
					housetypeOrientation: [{
						required: true,
						message: '请选择朝向',
						trigger: 'blur'
					}],
					housetypeHouse: [{
						required: true,
						message: '请选择所属楼盘',
						trigger: 'change'
					}],
				},
				previewVisible: false,
				previewImage: '',
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
			this.getHouseList()
		},
		methods: {
			handleCancel() {
				this.previewVisible = false;
			},

			async handlePreview(fileList) {
				this.previewImage = (fileList.url ? fileList.url : fileList.response.url) || file.preview;
				this.previewVisible = true;
			},

			photoChange({
				fileList
			}) {
				this.fileList = fileList
			},

			basicSubmit() {
				if (!this.fileList) {
					this.$message.error('请上传展示图');
					return false
				}
				this.$refs.basicForm.validate(valid => {
					if (valid) {
						let housetypePic = []
						console.log(this.fileList)
						for (var i = 0; i < this.fileList.length; i++) {
							housetypePic.push({
								name: this.fileList[i].name,
								size: this.fileList[i].size,
								status: this.fileList[i].status,
								url: this.fileList[i].url ? this.fileList[i].url : this.fileList[i].response.url
							});
						}

						this.$http.post('/admin/index.php/admin/house/houseTypeSave', {
							id: this.id,
							housetypeName: this.basicForm.housetypeName,
							housetypeCont: this.basicForm.housetypeCont,
							housetypeMain: this.basicForm.housetypeMain,
							housetypeInArea: this.basicForm.housetypeInArea,
							housetypeBuildArea: this.basicForm.housetypeBuildArea,
							housetypeOrientation: this.basicForm.housetypeOrientation,
							housetypeHouse: this.basicForm.housetypeHouse,
							housetypePic: JSON.stringify(housetypePic)
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/house/houseTypeInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.basicForm = res.data.data
						this.fileList = res.data.data.housetypePic


					}
				})
			},

			getHouseList() {
				this.$http.get('/admin/index.php/admin/house/houseFind').then(res => {
					if (res.data.code == 1) {
						this.houseList = res.data.data
					}
				})
			}
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}

	/* For demo */
	.ant-carousel>>>.slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
